import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {View, StyleSheet} from 'react-native';
import theme from '../../theme-config';
import DefensiveView from '../common/DefensiveView';

function getStyles() {
  return StyleSheet.create({
    container: {
      backgroundColor: theme.backgroundColor,
      flex: 1,
      justifyContent: 'center',
    },
  });
}

class TabBarScene extends PureComponent {
  styles = getStyles();

  fetchData = () => {
    if (this.props.fetchData) {
      this.props.fetchData();
    }
  };

  render() {
    const props = this.props;
    const styles = this.styles;

    return (
      <View style={styles.container}>
        <DefensiveView
          fetchData={this.fetchData}
          isFetching={props.isFetching ?? false}
          isFailure={props.isFailure ?? false}
          isRefreshing={props.isRefreshing ?? false}>
          {props.children}
        </DefensiveView>
      </View>
    );
  }
}

TabBarScene.propTypes = {
  children: PropTypes.object.isRequired,
  fetchData: PropTypes.func,
  isFailure: PropTypes.bool,
  isFetching: PropTypes.bool,
  isRefreshing: PropTypes.bool,
  title: PropTypes.string,
};

export default TabBarScene;
